import {
  faCaretDown,
  faCaretUp,
  faLock,
  faLockOpen,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changeFormulaType,
  changeFormulaTypeFromDays,
  changeFormulaTypeFromGranularToRaw,
} from "../../actions/formulaAction";
import { getFixedDosage, getUserDetail } from "../../utils/helper";
import DaysPopup from "../../pages/CustomFormulaBuilder/DaysPopup";
const TotalPrescibed = ({
  rawGramPerDayBeforeConversion,
  totalDosageRef,
  multiplier,
  prepMethod,
  isRawType,
  isLocked,
  setIsLocked,
  overallTotal,
  totalPacket,
  isPrescription,
  setMultiplier,
  prescriptionFormFields,
}) => {
  const [isTotalChanged, setIsTotalChanged] = useState(false);
  const [showDaysPopup, setShowDaysPopup] = useState(false);
  const [totalDosage, setTotalDosage] = useState(overallTotal.totalDosage);
  const dispatch = useDispatch();
  const isAllowed = getUserDetail()?.practitioner_status == 1;
  const formulas = useSelector((state) => state.formula.present.formulaSection);
  const singleHerbList = useSelector(
    (state) => state.formula.present.singleHerbList
  );
  useEffect(() => {
    setIsTotalChanged(true);
    if (isPrescription) {
      setTotalDosage(
        isRawType
          ? totalPacket * overallTotal.totalDosage
          : overallTotal.totalDosage
      );
    } else {
      setTotalDosage(overallTotal.totalDosage);
    }
  }, [overallTotal.totalDosage, totalPacket]);

  const getDosageToChange = (desiredGranularTotal) => {
    let existingGranularTotal = 0;

    // Calculate existing granular total from formulas
    formulas.forEach((formula) => {
      formula.formulaHerbs.forEach((herb) => {
        existingGranularTotal += herb.dosageInFloat; // Sum up the dosage from formula herbs
      });
    });

    // Calculate existing granular total from single herbs
    singleHerbList.forEach((herb) => {
      existingGranularTotal += herb.dosageInFloat; // Sum up the dosage from single herbs
    });

    // Calculate additional granular needed
    let additionalGranularNeeded = desiredGranularTotal - existingGranularTotal;

    // Calculate total raw amount needed based on ratios
    let totalRawNeeded = 0;

    // Calculate raw amounts for formulas
    formulas.forEach((formula) => {
      formula.formulaHerbs.forEach((herb) => {
        debugger;
        let rawAmount =
          (herb.dosageInFloat * herb.rawRatio ?? 1) / herb.granularUnit ?? 1;
        rawAmount = Number.isNaN(rawAmount) ? 0 : rawAmount;
        totalRawNeeded +=
          (rawAmount * additionalGranularNeeded) / existingGranularTotal; // Distributing the additional granular needed
      });
    });

    // Calculate raw amounts for single herbs
    singleHerbList.forEach((herb) => {
      let rawAmount =
        (herb.dosageInFloat * herb.rawRatio ?? 1) / herb.granularUnit ?? 1;
      rawAmount = Number.isNaN(rawAmount) ? 0 : rawAmount;
      totalRawNeeded +=
        (rawAmount * additionalGranularNeeded) / existingGranularTotal; // Distributing the additional granular needed
    });

    // Add existing raw amounts to total needed
    const totalExistingRawAmount =
      formulas.reduce((total, formula) => {
        return (
          total +
          formula.formulaHerbs.reduce(
            (sum, herb) =>
              sum +
              (isNaN(
                (herb.dosageInFloat * herb.rawRatio ?? 1) / herb.granularUnit ??
                  1
              )
                ? 0
                : (herb.dosageInFloat * herb.rawRatio ?? 1) /
                    herb.granularUnit ?? 1),
            0
          )
        );
      }, 0) +
      singleHerbList.reduce(
        (total, herb) =>
          total +
          (isNaN(
            (herb.dosageInFloat * herb.rawRatio ?? 1) / herb.granularUnit ?? 1
          )
            ? 0
            : (herb.dosageInFloat * herb.rawRatio ?? 1) / herb.granularUnit ??
              1),
        0
      );

    return totalExistingRawAmount + totalRawNeeded;
  };
  return (
    <table className="table total-table-section">
      {showDaysPopup && (
        <DaysPopup
          closePopup={() => setShowDaysPopup(false)}
          multiplier={multiplier}
          setMultiplier={setMultiplier}
          totalDosage={totalDosage}
          setTotalDosage={setTotalDosage}
          getDosageToChange={getDosageToChange}
          totalDosageRef={totalDosageRef}
          rawGramPerDayBeforeConversion={rawGramPerDayBeforeConversion}
        />
      )}
      <thead>
        <tr className="total-section prescribed">
          <td></td>
          <td>TOTAL PRESCRIBED</td>

          <td className={`text-right pr-5`}>
            {isRawType ? (
              `${totalDosage.toLocaleString("en-US", {
                maximumFractionDigits: 1,
                minimumFractionDigits: 1,
              })} grams`
            ) : (
              <div className="d-flex justify-content-end align-items-center">
                {prepMethod ? (
                  <p
                    className="small mr-1"
                    style={{
                      fontSize: "12px",
                      textAlign: "initial",
                      lineHeight: "1.3",
                      marginBottom: 0,
                    }}
                  >
                    Minimum {prepMethod.minimumGram}g, Maximum{" "}
                    {prepMethod.maximumGram}g.
                  </p>
                ) : (
                  ""
                )}
                <div className="d-flex align-items-center justify-content-end">
                  {/* <button
                  className={`lock-btn ${isLocked && "locked"}`}
                  type="button"
                  onClick={() => setIsLocked(!isLocked)}
                >
                  <FontAwesomeIcon icon={isLocked ? faLock : faLockOpen} />
                </button> */}
                  <div
                    ref={totalDosageRef}
                    className={` number-field mr-2  ${
                      isLocked && "outer-locked"
                    }`}
                    onClick={() => {
                      if (
                        rawGramPerDayBeforeConversion != null &&
                        totalDosage > 0
                      ) {
                        setShowDaysPopup(true);
                      }
                    }}
                    style={{
                      cursor:
                        rawGramPerDayBeforeConversion != null && totalDosage > 0
                          ? "pointer"
                          : "initial",
                    }}
                  >
                    <input
                      style={{
                        pointerEvents:
                          rawGramPerDayBeforeConversion != null &&
                          totalDosage > 0
                            ? "none"
                            : "auto",
                      }}
                      disabled={totalDosage == 0}
                      type="number"
                      min="0"
                      step="any"
                      value={totalDosage}
                      onChange={(e) => setTotalDosage(e.target.value)}
                      onBlur={(e) => {
                        dispatch(changeFormulaTypeFromGranularToRaw(true, 1));
                        dispatch(
                          changeFormulaType(
                            true,
                            getDosageToChange(parseFloat(e.target.value)),
                            null,
                            true
                          )
                        );
                        dispatch(changeFormulaTypeFromDays(false, 1));
                        totalDosageRef.current.style.border =
                          "1px solid transparent";
                      }}
                    />
                    {/* <div>
                      <div
                        className="icon"
                        onClick={() => {
                          dispatch(
                            changeFormulaType(
                              isRawType,
                              overallTotal.totalDosage +
                                (isTotalChanged ? 0.5 : 1)
                            )
                          );
                          totalDosageRef.current.style.border =
                            "1px solid transparent";
                          setIsTotalChanged(false);
                        }}
                      >
                        <FontAwesomeIcon icon={faCaretUp} />
                      </div>
                      <div
                        className="icon"
                        onClick={() => {
                          parseFloat(overallTotal.totalDosage) > 0
                            ? dispatch(
                                changeFormulaType(
                                  isRawType,
                                  overallTotal.totalDosage -
                                    (isTotalChanged ? 0.5 : 1)
                                )
                              )
                            : dispatch(changeFormulaType(isRawType, 0));
                          totalDosageRef.current.style.border =
                            "1px solid transparent";
                        }}
                      >
                        <FontAwesomeIcon icon={faCaretDown} />
                      </div>
                    </div> */}
                  </div>
                  grams
                </div>
              </div>
            )}
          </td>
          <td className="text-right">{isPrescription && 100}%</td>
          {!isRawType && <td></td>}
          {!isRawType && isAllowed && (
            <td className="text-right">
              {isPrescription
                ? (
                    overallTotal.totalPrice * (isRawType ? totalPacket : 1)
                  ).toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                    style: "currency",
                    currency: "USD",
                  })
                : overallTotal.totalPrice.toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                    style: "currency",
                    currency: "USD",
                  })}
            </td>
          )}
          <td></td>
        </tr>
      </thead>
    </table>
  );
};

export default TotalPrescibed;
